import { createContext, ReactNode, useContext } from 'react';

import { useMultipartUpload } from './useMultipartUpload';

type MultipartUploadManagerContextProps = ReturnType<typeof useMultipartUpload>;
const MultipartUploadManagerContext = createContext<
    MultipartUploadManagerContextProps | undefined
>(undefined);

type MultipartUploadManagerProviderProps = {
    children: ReactNode;
};

export const MultipartUploadManagerProvider = ({
    children,
}: MultipartUploadManagerProviderProps) => {
    const value = useMultipartUpload();

    return (
        <MultipartUploadManagerContext.Provider value={value}>
            {children}
        </MultipartUploadManagerContext.Provider>
    );
};

export const useMultipartUploadManager =
    (): MultipartUploadManagerContextProps => {
        const context = useContext(MultipartUploadManagerContext);

        if (context === undefined) {
            throw new Error(
                'useMultipartUploadManager must be used within a MultipartUploadManagerProvider',
            );
        }
        return context;
    };
